export const iconFontAwesomeHumanitarianTowerObservation = (
	<i className="fa-solid fa-tower-observation"></i>
);
